import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../styles/TicketsHome.module.scss';
import useAlert from '../../hooks/useAlert';
import { GetGenioLiteOptions, UserFeedbackTicketSubmit, getCheckDetails, CreateTicket } from '../../api';
import { CheckingValidComment, clickTracker, getSourceValue, handleRedirection, getProjectId, empList } from '../../lib/common';
import { onClickEvent } from '../../lib/gaAnalytics';
import { handleSetBannerTypeData } from '../../reducersAndActions/actions/appStateActions';
import DynamicSearchBar from '../DynamicSearchBar';
import { GenioWithAuth, usePopup } from '../../hooks';
import { useAppState } from '../../contexts/appState';
import { CommonPopup, OthersPopup } from '../Popups';
import QuickCheckPopup from '../Popups/QuickCheckPopup/QuickCheckPopup';
import RaiseTicketPopup from '../Popups/RaiseTicketPopup/RaiseTicketPopup';

const CS_CHAT_CITIES = [
  'hyderabad',
  'bangalore',
  'jaipur',
  'chandigarh',
  'delhi',
  'mumbai',
  'ahmedabad',
  'kolkata',
];

// Shows the CS chat banner only when the selected city's dialer_mapped_cityname is in CS_CHAT_CITIES
const isCsChatCity = (cityDetails) =>
  CS_CHAT_CITIES.includes(cityDetails?.dialer_mapped_cityname?.toLowerCase?.() || '');

function GenioOptions() {
  const [appState] = useAppState();
  const { popupObj } = appState;
  const navigate = useNavigate();
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const selectedBusinessData = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const selectedBusinessGenio = selectedBusinessData;
  const source = getSourceValue();
  const [optionsData, setOptionsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [issueComment, setIssueComment] = useState('');
  const [setAlert] = useAlert();
  const [setPopup] = usePopup();
  const [othersData, setOthersData] = useState([]);
  const [showFeedbackOptionModal, setShowFeedbackOptionModal] = useState(false);
  const [checkDetails, setCheckDetails] = useState({});
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const queryParams = new URLSearchParams(window.location.search);
  const projectId = getProjectId();

  const [, appDispatch] = useAppState();
  sessionStorage.removeItem('feedback');
  sessionStorage.removeItem('faqsFeedback');
  sessionStorage.removeItem('bannerType');
  sessionStorage.removeItem('activeBannerFlag');

  const getOptions = async () => {
    try {
      setLoading(true);
      const params = {
        parentId: selectedBusinessData?.parentId || '',
        city: selectedBusinessData?.city || '',
        department: profile?.department || '',
      };
      const res = await GetGenioLiteOptions(params);
      if (res.errorCode === 0) {
        const ecsFlag = res?.result?.ecsFlag || 0;
        sessionStorage.setItem('ecsFlag', JSON.stringify(ecsFlag));

        setOptionsData(res.result || []);
        sessionStorage.setItem('contractType', res?.result?.contractType || '');
      }
      setLoading(false);
    } catch (e) {
      console.log('Error: ', e);
    }
  };

  useEffect(() => {
    if (profile && profile?.empCode) {
      getOptions();
    }
  }, []);

  useEffect(() => {
    const handleGetDetail = async () => {
      try {
        const paramsData = {
          parentid: selectedBusinessData?.parentId || '',
          data_city: selectedBusinessData?.city || '',
        };
        const res = await getCheckDetails(paramsData);
        if (res.errorCode === 0) {
          setCheckDetails(res.result || {});
        }
      } catch (e) {
        console.log(e);
      }
    };
    if (selectedBusinessData?.parentId && showFeedbackOptionModal) {
      handleGetDetail();
    }
  }, [showFeedbackOptionModal, selectedBusinessData?.parentId]);

  const handleOptionClick = async (option, questionId = '') => {
    localStorage.setItem('searchQid', questionId);
    await clickTracker(`issue_${option?.trackerID}`, 'geniocs_faq_issue');
    onClickEvent(`GENIO-Main Page-FAQ Name`, option?.key || '', option?.key || '');
    if (option?.key === 'edit_my_business') {
      navigate('/genio/edit_business');
    } else if (option?.key === 'banner_jdrr') {
      handleSetBannerTypeData(appDispatch, {
        bannerTypeData: {},
      });
      navigate('/genio/banner');
    } else if (option?.key === 'ecs') {
      navigate('/genio/ecs');
    } else if (option?.key === 'contract_information') {
      navigate('/genio/contract');
    } else if (option?.key === 'leads') {
      navigate('/genio/leads');
    } else if (option.key === 'payments') {
      navigate('/genio/payments');
    } else if (option?.type === 'popup') {
      setPopup({
        open: true,
        popupType: 'postIssue',
        heading: 'Report an Issue',
        placeholder: 'Please write your query here, our support team will act on it within 24-48 hours',
      });
    } else if (option?.type === 'redirect') {
      window.location = option.url;
    } else if (option?.type === 'others') {
      setOthersData(option.data);
      setPopup({
        open: true,
        popupType: 'OthersPopup',
        heading: 'Others',
      });
    } else if (option?.type === 'create') {
      if (selectedBusinessData?.parentId && selectedBusinessData?.city) {
        navigate(`/genio/category_create_ticket`);
      }
    } else {
      navigate(`/genio/faq/${option.key}`);
    }
  };
  const handleClosePopup = () => {
    onClickEvent(`GenioMain-User`, 'Cancel', 'Cancel');
    document.body.style.overflow = 'unset';
    setIssueComment('');
    setPopup({});
  };

  const handleOthersClose = () => {
    document.body.style.overflow = 'unset';
    setPopup({});
  };

  const handleGrievanceSubmit = async () => {
    onClickEvent(`GenioMain-User`, 'Submit', 'Submit');
    handleClosePopup();
    try {
      if (CheckingValidComment(issueComment)) {
        const res = await UserFeedbackTicketSubmit(
          profile?.full_name || '',
          profile?.mobile || '',
          profile?.empEmail || '',
          profile?.city || '',
          'Other Issues',
          'User_NewCS',
          issueComment.trim(),
        );
        if (res.errorCode === 0) {
          setAlert({
            message: res.message || 'Success',
            status: true,
          });
        } else {
          setAlert({
            message: res?.message || 'Error',
            status: false,
          });
        }
      }
    } catch (e) {
      console.log('Error: ', e);
    }
  };
  const handleSubmit = async () => {
    try {
      if (selectedBusinessData?.mobile) {
        const paramsObj = {
          vertical: 'content',
          category: 'onboarding',
          ticket_creator: 'BUSINESS',
          nm: selectedBusinessData?.contractPersonName || selectedBusinessGenio?.companyName || '',
          created_by: profile?.mobile || '',
          mob: selectedBusinessData?.mobile || '',
          issue_type: checkDetails?.issueSubIssueDetails?.issue_type || '',
          issue_sub_type: selectedOption || '',
          issue_comment: '',
          document: [],
          oid: '',
          orderid: '',
          city: selectedBusinessData?.city || '',
          docid: selectedBusinessData?.docId || '',
          src: 'sales-genio',
          src_typ: empList.includes(profile.empCode)
            ? 'Genio – Market Research'
            : selectedBusinessData?.concern === 'client'
              ? 'client'
              : 'internal',
          src_nm: profile?.full_name || '',
          src_mob: profile?.mobile || '',
          projectId: '',
          parentId: selectedBusinessData?.parentId || '',
          compnm: selectedBusinessData?.companyName || '',
          bannerCta: queryParams?.get('bannerCta') || '',
          source: 'onboardingmodule_genioticket',
          ...(projectId === 'genio' && {
            agent_mngr_id: profile?.reporteeCode,
            agent_id: profile?.empCode,
          }),
        };
        const res = await CreateTicket(paramsObj);
        if (res.errorCode === 0) {
          setAlert({
            message: res?.result?.msg || 'Success!',
            status: true,
          });
        } else {
          setAlert({
            message:
              (res?.message && typeof res?.message === 'string' && res?.message) ||
              (res?.result && res?.result?.msg) ||
              'Something Went Wrong!',
            status: false,
          });
        }
        navigate(-1);
      } else {
        setAlert({
          message: 'No Mobile number found in the contract. Validate with Database team.',
          status: false,
        });
      }
    } catch (err) {
      console.log('Error: ', err);
    }
  };

  return (
    <>
      <section className="cspage cstickets no-highlighting">
        <DynamicSearchBar handleOptionClick={handleOptionClick} contractType={optionsData?.contractType} page="genio" />
        
        {isCsChatCity(selectedBusinessData?.cityDetails) && (
          <div className={styles.csChatBanner}>
            <div className={styles.csChatBannerIcon}>
              <svg width="44" height="44" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="30" cy="30" r="29" stroke="#4827EC" strokeWidth="2" fill="none" />
                <path
                  d="M19 28C19 22.4772 23.4772 18 29 18H31C36.5228 18 41 22.4772 41 28C41 33.5228 36.5228 38 31 38H27L20 42V37.28C19.36 36.14 19 34.83 19 33.4V28Z"
                  stroke="#4827EC"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                />
                <circle cx="25" cy="28" r="1.5" fill="#4827EC" />
                <circle cx="30" cy="28" r="1.5" fill="#4827EC" />
                <circle cx="35" cy="28" r="1.5" fill="#4827EC" />
              </svg>
            </div>
            <div className={styles.csChatBannerTitle}>You can now connect with a CS executive</div>
            <div className={styles.csChatBannerSubtitle}>Start a chat and get real-time help from our support team.</div>
            <button
              type="button"
              className={styles.csChatBannerBtn}
              onClick={() => {
                const redirectUrl = `https://cschat.justdial.com/?docid=${selectedBusinessGenio?.docId}&hidesearch=1&compname=${selectedBusinessGenio?.companyName || ''}&back=1`;
                handleRedirection(source, redirectUrl);
           }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 13.9189 4.6755 15.6798 5.80386 17.0601L4.5 21L8.68034 19.8242C9.70425 20.2568 10.825 20.5 12 20.5C16.4183 20.5 20 16.9183 20 12Z"
                  fill="white"
                />
                <circle cx="8.5" cy="12" r="1.2" fill="#3B1EE7" />
                <circle cx="12" cy="12" r="1.2" fill="#3B1EE7" />
                <circle cx="15.5" cy="12" r="1.2" fill="#3B1EE7" />
              </svg>
              <span>Start a New Chat</span>
            </button>
          </div>
        )}
        
        <div className="cshotkeybox p-20 pb-10">
          {loading ? (
            <div className="loader-container">
              <div className="bt-spinner" />
            </div>
          ) : (
            <>
              <div className="landingbox_text pl-20 pr-20">
                <div className="font15 fw700 color111">
                  {optionsData &&
                  optionsData?.contractType &&
                  ['paid', 'expiredShort'].includes(optionsData?.contractType)
                    ? 'Tell us how we can help?'
                    : 'Oops! The business seems to be a non-paid business'}
                </div>
                {optionsData &&
                  optionsData?.contractType &&
                  ['paid', 'expiredShort'].includes(optionsData?.contractType) && (
                    <div className="font11 fw400 color777 mt-5">
                      Our crew of superheroes are standing by for service &amp; support!
                    </div>
                  )}
              </div>

              <ul className="hotkeybox_listgroup">
                {optionsData &&
                  optionsData?.options &&
                  optionsData?.options?.length > 0 &&
                  optionsData?.options.map((each, idx) => (
                    <li key={idx} className={`${styles.Contract__ListGroupItem} `}>
                      <div
                        tabIndex={0}
                        role="button"
                        onKeyDown={() => {}}
                        onClick={() => {
                          if (each?.key === 'Digital') {
                            setShowFeedbackOptionModal(true);
                          } else {
                            handleOptionClick(each);
                          }
                        }}
                        className={`${styles.Contract__ListGroupAnchor} whitefill_animate`}
                      >
                        <div className={`csicon hotkeybox_icon ${each.icon}`} />
                        <div className={`${styles.Contract__ListGroupText} pl-12 pr-20`}>
                          <div className={`${styles.Contract__ListGroupTitle}  font14 fw600 color111`}>
                            {each.title}
                          </div>
                        </div>
                      </div>
                    </li>
                  ))}
              </ul>
            </>
          )}
        </div>
      </section>

      {popupObj?.popupType === 'postIssue' && (
        <CommonPopup
          comment={issueComment}
          setComment={setIssueComment}
          handleCommentSubmit={handleGrievanceSubmit}
          handleClosePopup={handleClosePopup}
        />
      )}

      {popupObj?.popupType === 'OthersPopup' && (
        <OthersPopup
          handleClosePopup={handleOthersClose}
          othersData={othersData}
          setAlert={setAlert}
          handleFaqRedirection={handleOptionClick}
        />
      )}
      {showFeedbackOptionModal && (
        <QuickCheckPopup
          showFeedbackOptionModal={showFeedbackOptionModal}
          setShowFeedbackOptionModal={setShowFeedbackOptionModal}
          checkDetails={checkDetails}
          setShowTicketModal={setShowTicketModal}
        />
      )}
      {showTicketModal && (
        <RaiseTicketPopup
          setShowTicketModal={setShowTicketModal}
          optionList={checkDetails?.issueSubIssueDetails?.disp_obj}
          setSelectedOption={setSelectedOption}
          selectedOption={selectedOption}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
}

export default GenioWithAuth(GenioOptions);
